
import OperativeView from './OperativeControl'

import React, { Component } from 'react';

// Externals
import classNames from 'classnames';
import compose from 'recompose/compose';

// Material helpers
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { withRouter } from 'react-router-dom';

// Shared components
import Portlet from 'components/Portlet';
import PortletHeader from 'components/PortletHeader';
import PortletLabel from 'components/PortletLabel';
import PortletToolbar from 'components/PortletToolbar';
import PortletContent from 'components/PortletContent';
import PortletFooter from 'components/PortletFooter';

// Material components
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import Popover from '@material-ui/core/Popover';
//import RefreshIcon from '@material-ui/icons/Refresh';
//import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined';
//import InfoIcon from '@material-ui/icons/Info';
import QueryBuilderIcon from '@material-ui/icons/QueryBuilder';
//import Button from '@material-ui/core/Button';
import HelpIcon from '@material-ui/icons/Help';
import PerfectScrollbar from 'react-perfect-scrollbar';
import CircularProgress from '@material-ui/core/CircularProgress';
import StopIcon from '@material-ui/icons/Stop';
import Divider from '@material-ui/core/Divider';
import Avatar from '@material-ui/core/Avatar';
import UpdateIcon from '@material-ui/icons/Update';
import ClearIcon from '@material-ui/icons/Clear';
                                              
import {getObjectives} from '../../../../services/getObjectives'

// Component styles
import styles from './styles';
import moment from 'moment-timezone'
import 'moment/locale/es'
moment.locale('es')

class QuickView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            typeGraph: 0,
            listObjectives: {},
            loadObjectiveData: false,
            dateMoment:moment().tz(sessionStorage.getItem('tz')).format("dddd, DD/MM/YYYY, h:mm:ss a"),
            isInfo:null,
            intervalId: null,
        };
    }

    tick=()=>{
        //console.log('recarga cada 5 minutos')
        sessionStorage.setItem("listsLoadsDisponibilidad",false)
        window.location.reload()
        sessionStorage.setItem("listsLoads",false)
        this.setState({
            typeGraph: 0,
            listObjectives: {},
            loadObjectiveData: false,
            dateMoment:moment().tz(sessionStorage.getItem('tz')).format("dddd, DD/MM/YYYY, h:mm:ss a"),
            isInfo:null
            
        })
        this.processData()
      }

    handleShowIsInfo = event => {
        this.setState({
            isInfo: event.currentTarget
        });
    };
    handleCloseIsInfo = () => {
        this.setState({
            isInfo: null
        });
    };

    componentDidMount() {
        const newInterval = setInterval(
            () => this.tick(),
            900000
          )
        this.setState({intervalId: newInterval})
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.loadObjectiveData===false && this.state.loadObjectiveData===false) {
            this.processData()
        }
        
    }

    componentWillUnmount() {
        clearInterval(this.state.intervalId)
    }

    processData = () => {
        const {params}=this.props
        if((sessionStorage.getItem("listsLoads"))==="true"){
            this.setState({
                listObjectives: JSON.parse(sessionStorage.getItem("listaData")),
                loadObjectiveData: true
            });
        }else{
            let token = sessionStorage.getItem('key')
            let user_id = sessionStorage.getItem('user')
            /*OBTIENE OBJETIVOS POR ESTADO*/
            getObjectives(user_id, token).then(data=>{
                sessionStorage.setItem("listaData",JSON.stringify(data))
                this.setState({
                    listObjectives: data,
                    loadObjectiveData: true
                });
            })
        }
    }
           

    render() {
        const { classes, className } = this.props;
        const { typeGraph, listObjectives, loadObjectiveData, dateMoment, isInfo} = this.state;
        const rootClassName = classNames(classes.root, className);
        const showIsInfo = Boolean(isInfo);
        if (loadObjectiveData===false) {
            return(
                <PortletContent>
                    <Typography
                    variant="h5"
                    >
                    <CircularProgress
                    variant="indeterminate"
                    size={24}
                    thickness={4}
                    />
                    <br/>
                        Cargando Información...
                    </Typography>
                </PortletContent>
            )
        }else if(loadObjectiveData===true){
            return (

                <Portlet
                        /*  {...rest} */
                        className={rootClassName}
                    >
                        <PortletHeader className={classes.header}
                        >
                            <PortletLabel
                                /*  icon={<DevicesIcon />} */
                                variant="h6"
                            />

                            <PortletToolbar>
                                <div>
                                    <IconButton
                                    onClick={this.handleShowIsInfo}
                                    >
                                        <HelpIcon color="infoIcon"/>
                                    </IconButton>
                                </div>
                                <div style={{
                                            display: 'flex',
                                            alignItems: 'center'
                                        }}>
                                    {/* <Typography >
                                    Última actualización:
                                    </Typography> */}
                                    
                                    <Avatar variant="rounded" className={classes.rounded}>
                                    <UpdateIcon /> 
                                    </Avatar>
                                    <Typography  className={classes.updateTime}   >
                                            &nbsp; Última actualización: {dateMoment} 
                                    </Typography>
                                    
                                </div>
                                
                            </PortletToolbar>
                        </PortletHeader>
                        <PortletContent className={classes.content}>
                            <Grid
                                container
                                spacing={10}
                            >
                                <Grid
                                    item
                                    xs={12}
                                    sm={12}
                                    md={12}
                                    xl={12}>
                                    <PerfectScrollbar>
                                    <Grid
                                    container
                                    direction="row"
                                    justify="flex-end"
                                    alignItems="center"
                                    style={{paddingTop:"10px"}}
                                    >
                                        
                                        <Popover
                                            anchorEl={isInfo}
                                            open={showIsInfo}
                                            onClose={this.handleCloseIsInfo}
                                            className={classes.popover}
                                            >
                                            <PortletContent className={classes.popoverPorlet}>
                                                <Grid className={classes.buttonClosed} >
                                                    <IconButton className={classes.buttonClosed} onClick={this.handleCloseIsInfo}><ClearIcon/></IconButton>
                                                </Grid>
                                                <Typography variant="body1" className={classes.textColorPopover} >Muestra estado de objetivos y/o servicios, ordenados por indisponibilidad de la última medición consolidada y 
                                                la disponibilidad total de la última hora representado por el porcentaje de Uptime.

                                                La Disponibilidad de la última medición consolidada se representa por colores:
                                                </Typography>
                                                <Divider/>
                                                <Grid
                                                container
                                                direction="row"
                                                justify="flex-start"
                                                alignItems="center"
                                                >
                                                    
                                                    <StopIcon color="primary" /><Typography variant="body2" className={classes.textColorPopover}>: Indica Downtime Global</Typography>
                                                </Grid>
                                                <Grid
                                                container
                                                direction="row"
                                                justify="flex-start"
                                                alignItems="center"
                                                >
                                                    <StopIcon className={classes.stopYellow} /><Typography variant="body2" className={classes.textColorPopover}>: Indica Downtime Parcial</Typography>
                                                </Grid>
                                                <Grid
                                                container
                                                direction="row"
                                                justify="flex-start"
                                                alignItems="center"
                                                >
                                                    <StopIcon className={classes.stopGreen} /><Typography variant="body2" className={classes.textColorPopover}>: Indica Uptime</Typography>
                                                </Grid>
                                                <Divider/>
                                                <Typography variant="body1" className={classes.textColorPopover}> 
                                                    Adicionalmente se muestra información de último estado del paso para todos los ISPs,  ordenados
                                                    por indisponibilidad y se muestra el promedio del periodo de tiempo de respuesta (rendimiento) en segundos
                                                </Typography>
                                            
                                            </PortletContent>
                                        </Popover>
                                    
                                    </Grid>
                                    <div style={{paddingTop:"1px"}}>
                                        {<Graph
                                            typeGraph={typeGraph}
                                            onInfo={this.handleInfo}
                                            listObjetivesData={listObjectives}/>}
                                    </div>
                                    

                                
                                    </PerfectScrollbar>
                                </Grid>
                            </Grid>
                            
                        </PortletContent>
                        
                        <PortletFooter className={classes.portletFooter}>
                        </PortletFooter>
                    </Portlet>
            )
        }
    }
}

function Graph(props) {
    const typeGraph = props.typeGraph;
    if (typeGraph === 0) {
        //console.log('a')
        return <OperativeView params={props} />;
    }
}



export default
    compose(withRouter, withStyles(styles))(QuickView);